import { render, staticRenderFns } from "./Rentals.vue?vue&type=template&id=bb70c3e0"
import script from "./Rentals.vue?vue&type=script&lang=ts"
export * from "./Rentals.vue?vue&type=script&lang=ts"
import style0 from "./Rentals.vue?vue&type=style&index=0&id=bb70c3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports